import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiUrl: 'https://recb.stefconnect.stef.com',
  keycloak: {
    url: 'https://kauthapp-qua.stef.com',
    realm: 'internal_digital',
    clientId: 'stef-digital-stef-connect-admin',
  },
};
